module.exports = __webpack_public_path__ + "img/q-travel.34a0f3ec.svg";